import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";

const SnackbarAlert = ({ type, children, onClose }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  // Don't render anything if no content
  const hasContent = children && children.toString().trim() !== "";
  if (!hasContent) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={type}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {children}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
